import { render, staticRenderFns } from "./PlanPrice.vue?vue&type=template&id=d0412c42&"
import script from "./PlanPrice.vue?vue&type=script&lang=js&"
export * from "./PlanPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports